module.exports = __webpack_public_path__ + "img/hotel_demo.29bd7b3b.png";